import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  StyleSheet,
  Modal,
  ScrollView,
} from "react-native";

import Fonts from "../../Resources/Fonts";
import Colors from "../../Resources/Color";
import GlobalStyles from "../../Resources/Styles";

import { Menu, MenuItem } from "react-native-material-menu";
import { useScreenDimensions, useDevice } from "../_layout";

import { observer, Observer } from "mobx-react";

import { MaterialIcons } from "@expo/vector-icons";
import { AntDesign } from "@expo/vector-icons";
import { Feather } from "@expo/vector-icons";
import Ionicons from "@expo/vector-icons/Ionicons";
import { Octicons } from "@expo/vector-icons";

import { v4 as uuidv4 } from "uuid";
import IconEmptyView from "../Components/IconEmptyView";

import { useTranslation } from "react-i18next";
import SearchBar from "../Components/SearchBar";
import AddFoodView from "./AddFoodView";
import { formatNumber } from "../utils/numberUtils";
import { MealNames } from "../../Resources/Constants";

import Svg, { Circle } from "react-native-svg";
import EditNutritionPlanGoalsView from "./EditNutritionPlanGoalsView";

const AddNutritionPlanView = observer(
  ({ isVisible, onClose, nutritionPlan }) => {
    const { t } = useTranslation();
    const { screenSize } = useScreenDimensions();
    const { isMobile } = useDevice();

    const [showingAddFood, setShowingAddFood] = useState(false);
    //Try to call it from the FoodOption view so I can erase the isSelected to pass to the popup

    const coach = nutritionPlan.coach
      ? nutritionPlan.coach
      : nutritionPlan.client.coach || null;

    const cancel = () => {
      //   client.resetAuxNutritionPlan();
      //   if (nutritionPlan) {
      //     nutritionPlan.setProperty("isSelected", false);
      //   }
      onClose();
    };

    const addFoodAction = (foodOption) => {
      nutritionPlan.setSelectedMeal(foodOption.meal);
      foodOption.meal.setSelectedFoodOption(foodOption);
      setShowingAddFood(true);
    };

    const HeaderButtons = () => {
      const Buttons = observer(({ bool }) => {
        const text = bool ? "save-string" : "cancel-string";
        const Save = () => {
          //   client.addOrEditNutritionPlan(nutritionPlan);
          if (nutritionPlan.canSaveAux) {
            nutritionPlan.saveAuxPlanChanges();
            onClose();
          }
        };
        const [isHovered, setIsHovered] = useState(false);

        return bool ? (
          <TouchableOpacity
            onPress={Save}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <View
              style={{
                backgroundColor: Colors.bubbleColor,
                borderRadius: 14,
                borderWidth: 1,
                justifyContent: "center",
                borderColor: Colors.bubbleColor,
                width: 80,
                height: 35,
                justifyContent: "center",
                alignItems: "center",
                opacity: !nutritionPlan.canSaveAux ? 0.5 : isHovered ? 0.7 : 1,
              }}
            >
              <Text
                style={{
                  textAlignVertical: "center",
                  textAlign: "center",
                  color: Colors.whiteColor,
                }}
              >
                {t(text)}
              </Text>
            </View>
          </TouchableOpacity>
        ) : (
          <TouchableOpacity
            onPress={cancel}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <View
              style={{
                // marginHorizontal: 20,
                backgroundColor: isHovered
                  ? Colors.redColor
                  : Colors.whiteColor,
                borderRadius: 14,
                borderWidth: 1,
                justifyContent: "center",
                borderColor: "red",
                width: 80,
                height: 35,
                justifyContent: "center",
                alignItems: "center",
                marginHorizontal: 10,
              }}
            >
              <Text
                style={{
                  textAlignVertical: "center",
                  textAlign: "center",
                  color: isHovered ? "white" : Colors.redColor,
                }}
              >
                {t(text)}
              </Text>
            </View>
          </TouchableOpacity>
        );
      });
      return (
        <View
          style={{
            flexDirection: "row",
            width: "100%",
            justifyContent: "flex-end",

            marginBottom: screenSize != "large" ? 8 : 16,
          }}
        >
          <Buttons bool={false} />
          <Buttons bool={true} />
        </View>
      );
    };

    const NutritionPlanInfo = observer(() => {
      const [isHovered, setIsHovered] = useState(false);

      const [isNotesHovered, setIsNotesHovered] = useState(false);

      const GoalsView = observer(() => {
        const MacroGoalViewwww = observer(() => {
          return (
            <View
              style={{
                width: 120,
                alignItems: "center",
              }}
            >
              <Text>{formatNumber(nutritionPlan.getMacroTotal("carbs"))}</Text>

              <View
                style={{
                  height: 0.1,
                  width: "100%",
                  backgroundColor: Colors.borderColor,
                  marginVertical: 4,
                }}
              />

              <Text>{formatNumber(nutritionPlan.carbsGoal)}</Text>

              <Text
                style={{
                  marginTop: 16,
                }}
              >
                Carbs (
                {formatNumber(
                  (nutritionPlan.getMacroTotal("carbs") /
                    nutritionPlan.carbsGoal) *
                    100
                )}
                %)
              </Text>
            </View>
          );
        });

        const MacroGoalView = observer(({ macro }) => {
          const total = nutritionPlan.getMacroTotal(macro);
          // const goal = nutritionPlan.carbsGoal;
          const goal =
            macro === "calories"
              ? nutritionPlan.caloriesGoal
              : macro === "carbs"
              ? nutritionPlan.carbsGoal
              : macro === "protein"
              ? nutritionPlan.proteinGoal
              : nutritionPlan.fatsGoal;

          const percent = goal > 0 ? Math.min(100, (total / goal) * 100) : 0;

          const text =
            macro === "calories"
              ? "calories-string"
              : macro === "carbs"
              ? "carbs-string"
              : macro === "protein"
              ? "protein-string"
              : "fats-string";

          const MacroGoalCircle = observer(() => {
            // const total = nutritionPlan.getMacroTotal("carbs");
            // const goal = nutritionPlan.carbsGoal;
            // clamp percent so we never over-draw
            // const percent = Math.min(100, (total / goal) * 100);

            const SIZE = 80;
            const STROKE_WIDTH = 8;
            const RADIUS = (SIZE - STROKE_WIDTH) / 2;
            const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

            const dashOffset = CIRCUMFERENCE * (1 - percent / 100);

            return (
              <View
                style={{
                  width: SIZE,
                  height: SIZE,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Svg width={SIZE} height={SIZE}>
                  {/* background ring */}
                  <Circle
                    stroke={Colors.borderColor}
                    fill="none"
                    cx={SIZE / 2}
                    cy={SIZE / 2}
                    r={RADIUS}
                    strokeWidth={STROKE_WIDTH}
                  />
                  {/* progress ring */}
                  <Circle
                    stroke={
                      macro === "carbs"
                        ? Colors.carbsColor
                        : macro === "protein"
                        ? Colors.proteinColor
                        : Colors.fatsColor
                    }
                    fill="none"
                    cx={SIZE / 2}
                    cy={SIZE / 2}
                    r={RADIUS}
                    strokeWidth={STROKE_WIDTH}
                    strokeDasharray={CIRCUMFERENCE}
                    strokeDashoffset={dashOffset}
                    strokeLinecap="round"
                    transform={`rotate(-90 ${SIZE / 2} ${SIZE / 2})`}
                  />
                </Svg>
                <View
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: SIZE,
                    height: SIZE,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Text
                    style={{
                      fontSize: 18,
                      fontWeight: "600",
                    }}
                  >
                    {formatNumber(total)}
                  </Text>
                  <Text
                    style={{
                      fontSize: 12,
                      color: Colors.grayColor,
                      marginTop: 4,
                    }}
                  >
                    {formatNumber(goal)}
                  </Text>
                </View>
              </View>
            );
          });

          const CaloriesGoalBar = observer(() => {
            const fraction = goal > 0 ? Math.min(1, total / goal) : 0;

            return (
              <View style={{ width: "100%", marginBottom: 24, gap: 8 }}>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "baseline",
                    paddingLeft: 8,
                  }}
                >
                  <Text style={{ fontSize: 20, fontWeight: "600" }}>
                    {total}
                  </Text>
                  <Text
                    style={{
                      fontSize: 14,
                      fontWeight: "500",
                      color: Colors.grayColor,
                    }}
                  >
                    {" "}
                    / {goal} kcal
                  </Text>
                </View>

                {/* 2) Bar container */}
                <View
                  style={{
                    height: 10,
                    backgroundColor: Colors.borderColor,
                    borderRadius: 5,
                    overflow: "hidden",
                  }}
                >
                  {/* 3) Filled portion */}
                  <View
                    style={{
                      width: `${fraction * 100}%`,
                      height: "100%",
                      backgroundColor: Colors.blackColor,
                    }}
                  />
                </View>
              </View>
            );
          });

          return macro === "calories" ? (
            <CaloriesGoalBar />
          ) : (
            <View
              style={{
                // width: "100%",
                // flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                gap: 8,
              }}
            >
              <MacroGoalCircle />

              <View
                style={{
                  alignItems: "center",
                  gap: 4,
                }}
              >
                <Text
                  style={{
                    fontSize: 20,
                    fontWeight: "500",
                  }}
                >
                  {t(text)}
                </Text>

                <Text style={{ fontSize: 16, color: Colors.grayColor }}>
                  {formatNumber(percent)}%
                </Text>
              </View>
            </View>
          );
        });

        return (
          <View
            style={{
              width: "100%",
              alignItems: "center",
            }}
          >
            <Text
              style={{
                color: Colors.blackColor,
                outlineStyle: "none",
                // paddingVertical: 16,
                fontWeight: "500",
                fontSize: 20,
                marginBottom: 16,
              }}
            >
              {t("goal-string")}
            </Text>

            <MacroGoalView macro={"calories"} />

            <View
              style={{
                width: "100%",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-around",
              }}
            >
              <MacroGoalView macro={"carbs"} />
              <MacroGoalView macro={"protein"} />
            </View>

            <MacroGoalView macro={"fats"} />
          </View>
        );
      });

      const GoalsViewScroll = observer(() => {
        const [showingEditGoals, setShowingEditGoals] = useState(false);

        const ToggleEditButton = ({ isHidden }) => {
          const [isHovered, setIsHovered] = useState(false);

          return (
            <TouchableOpacity
              onPress={
                // () => nutritionPlan.setProperty("showingEditGoals", true)
                () => setShowingEditGoals(true)
              }
              style={{
                paddingHorizontal: 8,
                flexDirection: "row",
                alignItems: "baseline",
                opacity: isHidden ? 0 : isHovered ? 0.5 : 1,
              }}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <Feather name="edit-3" size={13} color="black" />
              <Text style={{ marginLeft: 4 }}>{t("edit-string")}</Text>
            </TouchableOpacity>
          );
        };

        const MacroGoalView = observer(({ macro }) => {
          const total = nutritionPlan.getMacroTotal(macro);
          // const goal = nutritionPlan.carbsGoal;
          const goal =
            macro === "calories"
              ? nutritionPlan.caloriesGoal
              : macro === "carbs"
              ? nutritionPlan.carbsGoal
              : macro === "protein"
              ? nutritionPlan.proteinGoal
              : nutritionPlan.fatsGoal;

          const percent = goal > 0 ? Math.min(100, (total / goal) * 100) : 0;

          const text =
            macro === "calories"
              ? "calories-string"
              : macro === "carbs"
              ? "carbs-string"
              : macro === "protein"
              ? "protein-string"
              : "fats-string";

          const MacroGoalCircle = observer(() => {
            // const total = nutritionPlan.getMacroTotal("carbs");
            // const goal = nutritionPlan.carbsGoal;
            // clamp percent so we never over-draw
            // const percent = Math.min(100, (total / goal) * 100);

            const SIZE = 80;
            const STROKE_WIDTH = 8;
            const RADIUS = (SIZE - STROKE_WIDTH) / 2;
            const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

            const dashOffset =
              goal > 0
                ? CIRCUMFERENCE * (1 - percent / 100)
                : total > 0
                ? 0
                : CIRCUMFERENCE * (1 - 0 / 100);

            return (
              <View
                style={{
                  width: SIZE,
                  height: SIZE,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Svg width={SIZE} height={SIZE}>
                  {/* background ring */}
                  <Circle
                    stroke={Colors.borderColor}
                    fill="none"
                    cx={SIZE / 2}
                    cy={SIZE / 2}
                    r={RADIUS}
                    strokeWidth={STROKE_WIDTH}
                  />
                  {/* progress ring */}
                  <Circle
                    stroke={
                      macro === "carbs"
                        ? Colors.carbsColor
                        : macro === "protein"
                        ? Colors.proteinColor
                        : Colors.fatsColor
                    }
                    fill="none"
                    cx={SIZE / 2}
                    cy={SIZE / 2}
                    r={RADIUS}
                    strokeWidth={STROKE_WIDTH}
                    strokeDasharray={CIRCUMFERENCE}
                    strokeDashoffset={dashOffset}
                    strokeLinecap="round"
                    transform={`rotate(-90 ${SIZE / 2} ${SIZE / 2})`}
                  />
                </Svg>
                <View
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: SIZE,
                    height: SIZE,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Text
                    style={{
                      fontSize: 18,
                      fontWeight: "600",
                    }}
                  >
                    {formatNumber(total)}
                  </Text>
                  <Text
                    style={{
                      fontSize: 12,
                      color: Colors.grayColor,
                      marginTop: 4,
                    }}
                  >
                    {formatNumber(goal)}
                  </Text>
                </View>
              </View>
            );
          });

          const CaloriesGoalBar = observer(() => {
            const fraction =
              goal > 0 ? Math.min(1, total / goal) : total > 0 ? 1 : 0;

            return (
              <View style={{ width: "100%", marginBottom: 24, gap: 8 }}>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "baseline",
                    paddingLeft: 8,
                  }}
                >
                  <Text style={{ fontSize: 20, fontWeight: "600" }}>
                    {formatNumber(total)}
                  </Text>
                  <Text
                    style={{
                      fontSize: 14,
                      fontWeight: "500",
                      color: Colors.grayColor,
                    }}
                  >
                    {" "}
                    / {formatNumber(goal)} kcal
                  </Text>
                </View>

                {/* 2) Bar container */}
                <View
                  style={{
                    height: 10,
                    backgroundColor: Colors.borderColor,
                    borderRadius: 5,
                    overflow: "hidden",
                  }}
                >
                  {/* 3) Filled portion */}
                  <View
                    style={{
                      width: `${fraction * 100}%`,
                      height: "100%",
                      backgroundColor: Colors.blackColor,
                    }}
                  />
                </View>
              </View>
            );
          });

          return macro === "calories" ? (
            <CaloriesGoalBar />
          ) : (
            <View
              style={{
                // width: "100%",
                // flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                gap: 8,
              }}
            >
              <MacroGoalCircle />

              <View
                style={{
                  alignItems: "center",
                  gap: 4,
                }}
              >
                <Text
                  style={{
                    fontSize: 20,
                    fontWeight: "500",
                  }}
                >
                  {t(text)}
                </Text>

                <Text style={{ fontSize: 16, color: Colors.grayColor }}>
                  {formatNumber(percent)}%
                </Text>
              </View>
            </View>
          );
        });

        const Buttons = ({ bool }) => {
          const text = bool ? "save-string" : "cancel-string";

          const [isHovered, setIsHovered] = useState(false);

          const Save = () => {
            nutritionPlan.setProperty("showingEditGoals", false);
          };
          const Cancel = () => {
            // workout.setExercisesToAdd();
            nutritionPlan.setProperty("showingEditGoals", false);
          };

          return bool ? (
            <TouchableOpacity
              onPress={Save}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              style={{ marginRight: 10 }}
            >
              <View
                style={{
                  backgroundColor: Colors.bubbleColor,
                  borderRadius: 12,
                  borderWidth: 1,
                  justifyContent: "center",
                  borderColor: Colors.bubbleColor,
                  width: 76,
                  justifyContent: "center",
                  alignItems: "center",
                  opacity: isHovered ? 0.8 : 1,
                }}
              >
                <Text
                  style={{
                    textAlignVertical: "center",
                    textAlign: "center",
                    color: Colors.whiteColor,
                    paddingVertical: 5,
                  }}
                >
                  {t(text)}
                </Text>
              </View>
            </TouchableOpacity>
          ) : (
            <TouchableOpacity
              onPress={Cancel}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              style={{ marginRight: 10 }}
            >
              <View
                style={{
                  backgroundColor: isHovered ? Colors.redColor : "transparent",
                  borderRadius: 12,
                  borderWidth: 1,
                  justifyContent: "center",
                  borderColor: "red",
                  width: 76,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Text
                  style={{
                    textAlignVertical: "center",
                    textAlign: "center",
                    color: isHovered ? "white" : Colors.redColor,
                    paddingVertical: 5,
                  }}
                >
                  {t(text)}
                </Text>
              </View>
            </TouchableOpacity>
          );
        };

        return (
          <View
            style={{
              width: "100%",
              flex: 1,
              alignItems: "center",
            }}
          >
            <ScrollView
              style={{
                width: "100%",
              }}
              contentContainerStyle={{ alignItems: "center" }}
              showsVerticalScrollIndicator={false}
            >
              {nutritionPlan.showingEditGoals ? (
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    width: "100%",
                    marginBottom: 16,
                  }}
                >
                  {/* <ToggleEditButton isHidden={true} />
                <Text
                  style={{
                    color: Colors.blackColor,
                    fontWeight: "500",
                    fontSize: 20,
                  }}
                >
                  {t("goal-string")}
                </Text> */}

                  <Buttons bool={false} />
                  <Buttons bool={true} />
                </View>
              ) : (
                <View
                  style={{
                    width: "100%",
                  }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "baseline",
                      justifyContent: "space-between",
                      width: "100%",
                      marginBottom: 16,
                    }}
                  >
                    <ToggleEditButton isHidden={true} />
                    <Text
                      style={{
                        color: Colors.blackColor,
                        fontWeight: "500",
                        fontSize: 20,
                      }}
                    >
                      {t("goal-string")}
                    </Text>

                    <ToggleEditButton />
                  </View>

                  <MacroGoalView macro={"calories"} />

                  <View
                    style={{
                      width: "100%",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-around",
                    }}
                  >
                    <MacroGoalView macro={"carbs"} />
                    <MacroGoalView macro={"protein"} />
                  </View>

                  <MacroGoalView macro={"fats"} />
                </View>
              )}
            </ScrollView>

            {showingEditGoals && (
              <EditNutritionPlanGoalsView
                isVisible={showingEditGoals}
                onClose={() => setShowingEditGoals(false)}
                nutritionPlan={nutritionPlan}
              />
            )}
          </View>
        );
      });

      return (
        <View
          style={{
            width: screenSize != "large" ? "100%" : "28%",
            alignItems: "center",
            paddingHorizontal: screenSize != "large" ? 0 : 16,
            paddingVertical: 20,
          }}
        >
          <Text
            style={{
              alignSelf: "flex-start",
            }}
          >
            {t("nutritionPlanName-string")}
          </Text>
          <TextInput
            style={[
              GlobalStyles.textInputStyle,
              {
                marginTop: 8,
                borderRadius: 14,
                borderColor: isHovered
                  ? "rgba(0, 0, 0, 0.5)"
                  : Colors.borderColor,
              },
            ]}
            placeholder={t("newNutritionPlanName-string")}
            placeholderTextColor={Colors.grayColor}
            value={nutritionPlan.name}
            onChangeText={(text) => nutritionPlan.setProperty("name", text)}
            maxLength={45}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          />

          <Text
            style={{
              alignSelf: "flex-start",
              marginTop: 16,
            }}
          >
            {t("nutritionPlanNotes-string")}
          </Text>
          <TextInput
            style={[
              GlobalStyles.textInputStyle,
              {
                marginTop: 8,
                borderRadius: 14,
                borderColor: isNotesHovered
                  ? "rgba(0, 0, 0, 0.5)"
                  : Colors.borderColor,
                minHeight: 80,
              },
            ]}
            placeholder={t("newNutritionPlanNotes-string")}
            placeholderTextColor={Colors.grayColor}
            value={nutritionPlan.notes}
            onChangeText={(text) => nutritionPlan.setProperty("notes", text)}
            multiline={true}
            // numberOfLines={3}
            textAlignVertical="top"
            scrollEnabled={true}
            maxLength={100}
            onMouseEnter={() => !isMobile && setIsNotesHovered(true)}
            onMouseLeave={() => setIsNotesHovered(false)}
          />

          <View
            style={{
              width: "100%",
              backgroundColor: Colors.borderColor,
              height: 1,
              alignSelf: "center",
              marginVertical: 20,
            }}
          />

          {/* <GoalsView /> */}
          <GoalsViewScroll />
        </View>
      );
    });

    const MealBlock = observer(({ meal, idx }) => {
      const [isHovered, setIsHovered] = useState(false);
      const [isHoveredNotes, setIsHoveredNotes] = useState(false);

      const DeleteMealButton = ({ viewHover }) => {
        const [isHovered, setIsHovered] = useState(false);

        return (
          <TouchableOpacity
            onPress={() => nutritionPlan.deleteMeal(meal.id)}
            style={{
              alignSelf: "center",
              flexDirection: "row",
              borderWidth: 1,
              borderColor: Colors.redColor,
              borderRadius: 12,
              paddingVertical: 6,
              paddingHorizontal: 8,
              alignItems: "center",
              backgroundColor: isHovered ? Colors.redColor : "transparent",
              opacity: viewHover ? 1 : 0,
            }}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <Text
              style={{
                fontSize: 12,
                color: isHovered ? Colors.whiteColor : Colors.redColor,
              }}
            >
              {t("deleteMeal-string")}
            </Text>
          </TouchableOpacity>
        );
      };

      const MealTitleMenu = () => {
        const [isHovered, setIsHovered] = useState(false);

        const [showingTitleMenu, setShowingTitleMenu] = useState(false);
        const showTitleMenu = () => setShowingTitleMenu(true);

        const setTitle = (title) => {
          meal.setProperty("name", title);
          setShowingTitleMenu(false);
        };

        const MenuItemView = ({ index }) => {
          const [isHovered, setIsHovered] = useState(false);

          return index === 0 ? (
            <MenuItem
              onPress={() => setTitle(MealNames.BREAKFAST)}
              style={{ minWidth: 180 }}
              textStyle={{
                fontSize: 14,
                fontWeight: isHovered ? "600" : "normal",
              }}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {t(MealNames.BREAKFAST)}
            </MenuItem>
          ) : index === 1 ? (
            <MenuItem
              onPress={() => setTitle(MealNames.LUNCH)}
              style={{ minWidth: 180 }}
              textStyle={{
                fontSize: 14,
                fontWeight: isHovered ? "600" : "normal",
              }}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {t(MealNames.LUNCH)}
            </MenuItem>
          ) : index === 2 ? (
            <MenuItem
              onPress={() => setTitle(MealNames.DINNER)}
              style={{ minWidth: 180 }}
              textStyle={{
                fontSize: 14,
                fontWeight: isHovered ? "600" : "normal",
              }}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {t(MealNames.DINNER)}
            </MenuItem>
          ) : (
            <MenuItem
              onPress={() => setTitle(MealNames.SNACK)}
              style={{ minWidth: 180 }}
              textStyle={{
                fontSize: 14,
                fontWeight: isHovered ? "600" : "normal",
              }}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {t(MealNames.SNACK)}
            </MenuItem>
          );
        };

        return (
          <Menu
            visible={showingTitleMenu}
            anchor={
              <TouchableOpacity
                onPress={showTitleMenu}
                style={{
                  opacity: isHovered ? 0.5 : 1,
                  flexDirection: "row",
                  alignItems: "center",
                }}
                onMouseEnter={() => !isMobile && setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <Text style={{ fontWeight: "500", fontSize: 16 }}>
                  {t(meal.name)}
                </Text>
                <Feather
                  name="chevron-down"
                  size={20}
                  color={Colors.bubbleColorConstant}
                  style={{ paddingHorizontal: 4 }}
                />
              </TouchableOpacity>
            }
            style={GlobalStyles.menu}
            onRequestClose={() => setShowingTitleMenu(false)}
          >
            <MenuItemView index={0} />
            <MenuItemView index={1} />
            <MenuItemView index={2} />
            <MenuItemView index={3} />
          </Menu>
        );
      };

      const FoodOptionButton = observer(({ foodOption, idx }) => {
        const [isHovered, setIsHovered] = useState(false);
        return (
          <TouchableOpacity
            onPress={() =>
              meal.setProperty("defaultFoodOption", foodOption.order)
            }
            style={{
              alignSelf: "center",
              // marginVertical: 15,
              flexDirection: "row",
              borderWidth: 1,
              borderRadius: 14,
              paddingVertical: 6,
              paddingHorizontal: 8,
              alignItems: "center",
              borderColor:
                foodOption.isDefault || isHovered
                  ? Colors.bubbleColor
                  : "black",
              backgroundColor:
                foodOption.isDefault || isHovered
                  ? Colors.bubbleColor
                  : "transparent",
              opacity: isHovered ? 0.7 : 1,
            }}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <Text
              style={{
                // fontWeight: "500",
                fontSize: 14,
                // fontWeight: isHovered ? "500" : "normal",
                color: foodOption.isDefault || isHovered ? "white" : "black",
              }}
            >
              {/* {t("foodOption-string")} {foodOption.order + 1} */}
              {t("foodOption-string", { optionNumber: foodOption.order + 1 })}
            </Text>
          </TouchableOpacity>
        );
      });

      const AddFoodOptionButton = () => {
        const [isHovered, setIsHovered] = useState(false);

        return (
          <TouchableOpacity
            onPress={() => meal.addFoodOption()}
            style={{
              alignSelf: "center",
              flexDirection: "row",
              borderRadius: 14,
              paddingVertical: 6,
              paddingHorizontal: 8,
              alignItems: "center",
              backgroundColor: isHovered
                ? "rgba(0, 0, 0, 0.05)"
                : "transparent",
            }}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <AntDesign name="plus" size={18} />
            <Text
              style={{
                marginLeft: 4,
                fontSize: 14,
              }}
            >
              {meal.foodOptions.length > 1
                ? t("addOption-string")
                : t("addFoodOptions-string")}
            </Text>
          </TouchableOpacity>
        );
      };

      const DeleteFoodOptionButton = () => {
        const [isHovered, setIsHovered] = useState(false);

        return (
          meal.foodOptions.length > 1 && (
            <TouchableOpacity
              onPress={() => meal.deleteDefaultFoodOption()}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <Ionicons
                name={isHovered ? "trash" : "trash-outline"}
                size={20}
                color={"red"}
                style={{
                  paddingHorizontal: 4,
                  // opacity: isHovered ? 0.5 : 1,
                }}
              />
            </TouchableOpacity>
          )
        );
      };

      const FoodOptionBlock = observer(({ foodOption }) => {
        const FoodRow = observer(({ food, index }) => {
          const [showingAddEquivalence, setShowingAddEquivalence] =
            useState(false);

          const Row = observer(({ food }) => {
            const DeleteFoodButton = () => {
              const [isHovered, setIsHovered] = useState(false);

              return (
                <TouchableOpacity
                  onPress={() => {
                    if (food.food) {
                      food.food.deleteEquivalence(food.id);
                    } else {
                      foodOption.deleteFood(food.id);
                    }
                  }}
                  // disabled={foodOption.foods.length === 1}
                  onMouseEnter={() => !isMobile && setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                >
                  <Ionicons
                    name={isHovered ? "trash" : "trash-outline"}
                    size={20}
                    color={"red"}
                    style={{
                      paddingLeft: 8,
                    }}
                  />
                </TouchableOpacity>
              );
            };

            const QuantityTextBox = observer(({ food }) => {
              const [isHovered, setIsHovered] = useState(false);

              const [text, setText] = useState(String(food.quantity ?? ""));

              const handleChange = (text) => {
                const formattedText = text.replace(",", ".");

                const aux = Number(formattedText);

                if (!isNaN(aux)) {
                  setText(formattedText);

                  const numAux = Number(formattedText);

                  food.setProperty("quantity", numAux);

                  food.equivalences.forEach((eq) => {
                    eq.adjustKcal(food.getCalories);
                  });
                }
              };

              const parentQty = food.food?.quantity;

              useEffect(() => {
                // when either own qty or parent qty changes, resync the textbox
                setText(String(food.quantity ?? ""));
              }, [food.quantity, parentQty]);

              return (
                <View
                  style={{
                    borderColor: isHovered ? "gray" : Colors.grayColor,
                    // width: 80,
                    height: 24,
                    borderRadius: screenSize === "small" ? 8 : 10,
                    borderWidth: isHovered ? 1.2 : 1,
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "row",
                    paddingRight: 8,
                    marginRight: 16,
                  }}
                  onMouseEnter={() => !isMobile && setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                >
                  <TextInput
                    value={text}
                    onChangeText={handleChange}
                    // onFocus={() =>
                    //   serie.exercise.workout.setSelectedExercise(serie.exercise)
                    // }
                    // keyboardType="decimal-pad"
                    inputMode="numeric"
                    style={{
                      // width: "100%",
                      outlineStyle: "none",
                      maxWidth: 60,
                      // backgroundColor: "red",
                      height: 24,
                      borderRadius: screenSize === "small" ? 8 : 10,
                      textAlign: "center",
                      color: "black",
                      fontSize: screenSize === "small" ? 10.5 : 11,
                    }}
                    maxLength={10}
                  />

                  <Text>g</Text>
                </View>
              );
            });

            const MacrosInfo = observer(({ food }) => {
              return (
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <View
                    style={{
                      alignItems: "center",
                      width: 80,
                    }}
                  >
                    <Text style={{ fontSize: 14 }} numberOfLines={1}>
                      {formatNumber(food.getCalories)} kcal
                    </Text>
                  </View>

                  <View
                    style={{
                      alignItems: "center",
                      width: 80,
                    }}
                  >
                    <Text style={{ fontSize: 14 }} numberOfLines={1}>
                      {formatNumber(food.getCarbs)} g
                    </Text>
                  </View>

                  <View
                    style={{
                      alignItems: "center",
                      width: 80,
                    }}
                  >
                    <Text style={{ fontSize: 14 }} numberOfLines={1}>
                      {formatNumber(food.getProtein)} g
                    </Text>
                  </View>

                  <View
                    style={{
                      alignItems: "center",
                      width: 80,
                    }}
                  >
                    <Text style={{ fontSize: 14 }} numberOfLines={1}>
                      {formatNumber(food.getFats)} g
                    </Text>
                  </View>
                </View>
              );
            });

            return (
              <View
                style={{
                  width: "100%",
                  flexDirection: "row",
                  marginTop: food.food != null ? 8 : 0,
                  // padding: 8,
                  alignItems: "center",
                  paddingLeft: food.food != null ? 16 : 0,
                }}
              >
                <View
                  style={{
                    flex: 1,
                    paddingRight: 8,
                    gap: 0,
                    justifyContent: "center",
                  }}
                >
                  <Text
                    style={{ flex: 1, fontSize: 12, fontWeight: "600" }}
                    numberOfLines={2}
                  >
                    {food.name}
                  </Text>
                  {food.brand && food.food == null && (
                    <Text style={{ fontSize: 10, color: "#666" }}>
                      {food.brand}
                    </Text>
                  )}
                </View>

                {food.food === null && (
                  <TouchableOpacity
                    onPress={() => setShowingAddEquivalence(true)}
                    style={{
                      marginRight: 8,
                    }}
                  >
                    <AntDesign
                      name="pluscircleo"
                      size={20}
                      color={Colors.grayColor}
                    />
                  </TouchableOpacity>
                )}

                <QuantityTextBox food={food} />

                <MacrosInfo food={food} />

                <DeleteFoodButton />
              </View>
            );
          });

          return (
            food && (
              <View
                style={{
                  width: "100%",
                  marginTop: index !== 0 ? 8 : 0,
                  padding: 8,
                  alignItems: "center",
                }}
              >
                <Row food={food} />

                {food.equivalences &&
                  food.equivalences.length > 0 &&
                  food.equivalences.map((food, index) => (
                    <Row food={food} key={index} />
                  ))}

                {showingAddEquivalence && (
                  <AddFoodView
                    isVisible={showingAddEquivalence}
                    onClose={() => setShowingAddEquivalence(false)}
                    foodOption={foodOption}
                    food={food}
                    coach={coach}
                  />
                )}
              </View>
            )
          );
        });

        const AddFoodButton = () => {
          const [isHovered, setIsHovered] = useState(false);

          return (
            <TouchableOpacity
              onPress={() => addFoodAction(foodOption)}
              style={{
                flexDirection: "row",
                borderWidth: 1,
                borderColor: "black",
                borderRadius: 14,
                paddingVertical: 4,
                paddingHorizontal: 8,
                opacity: isHovered ? 0.5 : 1,
              }}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <AntDesign name="plus" size={16} color={"black"} />
              <Text
                style={{
                  marginLeft: 4,
                  color: "black",
                }}
              >
                {t("addFood-string")}
              </Text>
            </TouchableOpacity>
          );
        };

        const TotalInfo = observer(({ foodOption }) => {
          return (
            foodOption.foods.length > 0 && (
              <View style={{ flexDirection: "row", alignItems: "center" }}>
                {/* <Text style={{ marginRight: 16 }}>Total:</Text> */}

                <View
                  style={{
                    alignItems: "center",
                    width: 80,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 14,
                      // fontWeight: "400",
                    }}
                    numberOfLines={1}
                  >
                    {formatNumber(foodOption.totalCalories)} kcal
                  </Text>
                </View>
                <View
                  style={{
                    alignItems: "center",
                    width: 80,
                  }}
                >
                  <Text style={{ fontSize: 14 }} numberOfLines={1}>
                    {formatNumber(foodOption.totalCarbs)} g
                  </Text>
                </View>

                <View
                  style={{
                    alignItems: "center",
                    width: 80,
                  }}
                >
                  <Text style={{ fontSize: 14 }} numberOfLines={1}>
                    {formatNumber(foodOption.totalProtein)} g
                  </Text>
                </View>
                <View
                  style={{
                    alignItems: "center",
                    width: 80,
                  }}
                >
                  <Text style={{ fontSize: 14 }} numberOfLines={1}>
                    {formatNumber(foodOption.totalFats)} g
                  </Text>
                </View>

                <Ionicons
                  name={"trash-outline"}
                  size={20}
                  color={"red"}
                  style={{
                    paddingLeft: 8,
                    opacity: 0,
                  }}
                />
              </View>
            )
          );
        });

        const HeaderView = observer(({ foodOption }) => {
          return (
            foodOption.foods.length > 0 && (
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  paddingHorizontal: 8,
                }}
              >
                <TouchableOpacity
                  onPress={() =>
                    meal.setProperty("isShowingFoods", !meal.isShowingFoods)
                  }
                  style={{ marginRight: 8 }}
                >
                  <Feather
                    name={
                      meal.isShowingFoods ? "chevron-down" : "chevron-right"
                    }
                    size={24}
                    color={Colors.bubbleColorConstant}
                    style={{ paddingHorizontal: 8 }}
                  />
                </TouchableOpacity>

                <View
                  style={{
                    alignItems: "center",
                    minWidth: 80,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 14,
                      fontWeight: "500",
                      color: Colors.grayColor,
                    }}
                  >
                    {t("calories-string")}
                  </Text>
                </View>
                <View
                  style={{
                    alignItems: "center",
                    minWidth: 80,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 14,
                      fontWeight: "500",
                      color: Colors.grayColor,
                    }}
                  >
                    {t("carbs-string")}
                  </Text>
                </View>

                <View
                  style={{
                    alignItems: "center",
                    minWidth: 80,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 14,
                      fontWeight: "500",
                      color: Colors.grayColor,
                    }}
                  >
                    {t("protein-string")}
                  </Text>
                </View>
                <View
                  style={{
                    alignItems: "center",
                    minWidth: 80,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 14,
                      fontWeight: "500",
                      color: Colors.grayColor,
                    }}
                  >
                    {t("fats-string")}
                  </Text>
                </View>

                <Ionicons
                  name={"trash-outline"}
                  size={20}
                  color={"red"}
                  style={{
                    paddingLeft: 8,
                    opacity: 0,
                  }}
                />
              </View>
            )
          );
        });

        return (
          <View>
            <HeaderView foodOption={foodOption} />
            {foodOption.foods &&
              meal.isShowingFoods &&
              foodOption.foods.map((food, index) => (
                <FoodRow food={food} index={index} key={index} />
              ))}

            {foodOption.foods.length > 0 && (
              <View
                style={{
                  height: 0.1,
                  width: "100%",
                  backgroundColor: Colors.grayColor,
                  marginTop: 8,
                }}
              />
            )}

            <View
              style={{
                flexDirection: "row",
                marginVertical: 16,
                paddingRight: 8,
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <AddFoodButton />

              <TotalInfo foodOption={foodOption} />
            </View>
          </View>
        );
      });

      return (
        <View
          style={{
            marginBottom: 15,
            borderLeftWidth: 5,
            // borderColor: "gray",
            borderLeftColor: Colors.bubbleColor,
            borderRadius: 5,
            paddingLeft: 8,
          }}
        >
          {/* {idx !== 0 && <View style={styles.sectionSeparator} />} */}
          <View
            style={{
              flexDirection: "row",
              width: "100%",
              alignItems: "center",
              paddingBottom: 8,
              justifyContent: "space-between",
            }}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <MealTitleMenu />
            {nutritionPlan.meals.length > 1 && (
              <DeleteMealButton viewHover={isHovered} />
            )}
          </View>

          <TextInput
            style={[
              styles.questionInputStyle,
              {
                fontSize: screenSize === "large" ? 14 : 12,
                borderColor: isHoveredNotes
                  ? "rgba(0, 0, 0, 0.5)"
                  : Colors.borderColor,
              },
            ]}
            placeholder={t("mealNotes-string")}
            placeholderTextColor={Colors.grayColor}
            value={meal.notes}
            onChangeText={(text) => meal.setProperty("notes", text)}
            multiline={true}
            numberOfLines={screenSize === "large" ? 2 : 3}
            onMouseEnter={() => !isMobile && setIsHoveredNotes(true)}
            onMouseLeave={() => setIsHoveredNotes(false)}
          />
          {meal.canDisplayFoodOptionsRow && (
            <View
              style={{
                flexDirection: "row",
                // justifyContent: "space-between",
                alignItems: "center",
                marginVertical: 8,
                gap: 8,
              }}
            >
              {meal.foodOptions &&
                meal.foodOptions.length > 1 &&
                meal.sortedFoodOptions.map((foodOption, index) => (
                  <FoodOptionButton
                    foodOption={foodOption}
                    idx={index}
                    key={index}
                  />
                ))}

              <View style={{ flex: 1 }} />

              <DeleteFoodOptionButton />
              <AddFoodOptionButton />
            </View>
          )}

          {meal.getDefaultFoodOption && (
            <FoodOptionBlock foodOption={meal.getDefaultFoodOption} />
          )}
        </View>
      );
    });

    const AddMealButton = () => {
      const [isHovered, setIsHovered] = useState(false);

      return (
        <TouchableOpacity
          onPress={() => nutritionPlan.addMeal()}
          style={{
            alignSelf: "center",
            marginVertical: 15,
            flexDirection: "row",
            borderWidth: 1,
            borderRadius: 14,
            paddingVertical: 6,
            paddingHorizontal: 8,
            alignItems: "center",
            borderStyle: "dashed",
            borderColor: Colors.grayColor,
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <AntDesign name="plus" size={18} />
          <Text
            style={{
              marginLeft: 4,
              // fontWeight: "500",
              fontSize: 16,
              fontWeight: isHovered ? "500" : "normal",
            }}
          >
            {t("addMeal-string")}
          </Text>
        </TouchableOpacity>
      );
    };

    return (
      <Modal
        animationType="fade"
        transparent={true}
        visible={isVisible}
        onRequestClose={cancel}
      >
        <View style={GlobalStyles.centeredView}>
          <View style={GlobalStyles.touchableBackground} />
          <View
            style={[
              styles.modalView,
              {
                position: "absolute",
                // maxHeight: "90%",
                // minHeight: screenSize != "large" ? 200 : 500,
                padding: screenSize === "small" ? 8 : 24,
                // width: screenSize === "small" && "90%",
                height: "90%",
                width: "90%",
              },
            ]}
            onStartShouldSetResponder={() => false}
          >
            <HeaderButtons />

            {screenSize != "large" ? (
              <ScrollView
                style={{
                  flex: 1,
                  flexDirection: screenSize != "large" ? "column" : "row",
                  borderWidth: screenSize != "large" ? 0 : 1,
                  borderRadius: screenSize != "large" ? 0 : 16,
                  borderColor: Colors.borderColor,
                  maxWidth: screenSize != "large" ? 500 : 1000,
                  minWidth: screenSize === "medium" ? 500 : 250,
                }}
                contentContainerStyle={{
                  height: "100%",
                }}
                showsVerticalScrollIndicator={false}
              >
                <View
                  style={{
                    height: "100%",
                  }}
                >
                  <NutritionPlanInfo />
                  {nutritionPlan.meals &&
                    nutritionPlan.meals.map((meal, index) => (
                      <MealBlock meal={meal} idx={index} key={index} />
                    ))}
                  <AddMealButton />
                </View>
              </ScrollView>
            ) : (
              <View
                style={{
                  flexDirection: screenSize != "large" ? "column" : "row",
                  flex: 1,
                  // minWidth: 1000,
                  height: "100%",
                  borderRadius: 16,
                  borderWidth: 1,
                  borderColor: Colors.borderColor,
                  justifyContent: "space-between",
                }}
              >
                <NutritionPlanInfo />
                <View
                  style={{
                    width: 1,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <View
                    style={{
                      width: 1,
                      height: "90%",
                      backgroundColor: Colors.borderColor,
                      flexShrink: 0,
                    }}
                  />
                </View>

                <View
                  style={{
                    flex: 1,
                    padding: 10,
                  }}
                >
                  <ScrollView
                    style={{
                      marginHorizontal: screenSize != "large" ? 4 : 0,
                    }}
                    contentContainerStyle={{ height: "100%" }}
                    showsVerticalScrollIndicator={false}
                  >
                    <Text
                      style={{
                        width: "100%",
                        color: Colors.blackColor,
                        outlineStyle: "none",
                        paddingVertical: 16,
                        fontWeight: "500",
                        fontSize: 24,
                      }}
                    >
                      {t("mealsDistribution-string")}
                    </Text>
                    {nutritionPlan.meals &&
                      nutritionPlan.meals.map((meal, index) => (
                        <MealBlock meal={meal} idx={index} key={index} />
                      ))}
                    <AddMealButton />
                  </ScrollView>
                </View>
              </View>
            )}
          </View>
        </View>

        {showingAddFood &&
          nutritionPlan &&
          nutritionPlan.selectedMeal &&
          nutritionPlan.selectedMeal.selectedFoodOption && (
            <AddFoodView
              isVisible={showingAddFood}
              onClose={() => setShowingAddFood(false)}
              foodOption={nutritionPlan.selectedMeal.selectedFoodOption}
              coach={coach}
            />
          )}
      </Modal>
    );
  }
);

const styles = StyleSheet.create({
  modalView: {
    borderRadius: 18,
    backgroundColor: Colors.whiteColor,
  },
  questionInputStyle: {
    width: "100%",
    borderColor: Colors.borderColor,
    backgroundColor: Colors.whiteColor,
    color: Colors.blackColor,
    borderWidth: 0.1,
    padding: 8,
    borderRadius: 10,
    outlineStyle: "none",
  },
  sectionInputStyle: {
    width: "100%",
    color: Colors.blackColor,
    outlineStyle: "none",
    paddingVertical: 4,
    fontWeight: "600",
  },
  sectionSeparator: {
    width: "95%",
    backgroundColor: Colors.borderColor,
    height: 1,
    alignSelf: "center",
    marginBottom: 15,
  },
});

export default AddNutritionPlanView;
